export const WELCOME_MODAL = 'WELCOME_MODAL';
export const LOG_OUT_MODAL = 'LOG_OUT_MODAL';
export const ERROR_MODAL = 'ERROR_MODAL';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const SUCCESS_ORDER = 'SUCCESS_ORDER';

export const CALCULATOR_MODAL = 'CALCULATOR_MODAL';

export const SIDEBAR_MODAL = 'SIDEBAR_MODAL';
